import { toast } from "sonner";
import { planById } from "@/lib/plans";

/** Where a plan change will hand over to Stripe Checkout. Until that's connected, nothing is charged or changed. */
export const startCheckout = async (planId) => {
  toast.info(`Online payment isn't connected yet, so you're still on your current plan. ${planById(planId).name} will be available here soon.`);
};
